import client01 from '../assets/testimonials/1.webp'
import client02 from '../assets/testimonials/2.webp'
import client03 from '../assets/testimonials/3.webp'
import client04 from '../assets/testimonials/4.webp'

export const bioAuthor = [
    {
        name: 'Estilo',
        description: 'Ficção, Medieval'
    },
    {
        name: 'País',
        description: 'Brasil'
    },
    {
        name: 'Site Oficial',
        description: 'depaulalivros.com'
    },
    {
        name: 'Formação',
        description: 'História'
    },
    {
        name: 'Livros',
        description: '11'
    },
    {
        name: 'E-mail',
        description: 'depaulalivros@depaula.com'
    },
]

export const TotalSell = [
    {
        ico:'fa-solid fa-book',
        end: 21000,
        label:'Livros Vendidos'
    },
    {
        ico:"fa-solid fa-trophy",
        end: 23,
        label:'Prêmios'
    },
    {
        ico:'fa-solid fa-book',
        end: 7000,
        label:'Leitores Ativos'
    },
    {
        ico:'fa-regular fa-hourglass-half',
        end: 50000,
        label:'Horas de leitura'
    },

]

export const testimonials = [
    {
        description:'Fiquei completamente imerso na história desde a primeira página. A atenção aos detalhes e a riqueza dos personagens fazem deste livro uma leitura obrigatória para qualquer amante de ficção histórica.' ,
        img:client01,
        name:'Aline Camille'
    },
    {
        description:'Este livro não é apenas uma história; é uma experiência. A forma como o autor entrelaça fatos históricos com uma narrativa emocionante é simplesmente brilhante.' ,
        img:client02,
        name:'Juliana Borges'
    },
    {
        description:'A história é cheia de reviravoltas e mantém você na ponta da cadeira até o final. Recomendo a qualquer um que adore aventuras medievais com um toque de mistério.' ,
        img:client03,
        name:'Murilo Camilo'
    },
    {
        description:'É evidente que o autor fez uma pesquisa extensa para criar um mundo tão autêntico. Aprendi tanto sobre o período medieval enquanto me divertia com uma narrativa envolvente.' ,
        img:client04,
        name:'Lucas Pereira'
    },
]

export const contacts = [
    {
        class:"fa-solid fa-location-dot",
        label:'Endereço',
        info01:'Rua Botafogo n34 - Santíssimo',
        info02:'Rio de Janeiro, RJ'
    },
    {
        class:"fa-solid fa-phone",
        label:'Telefone',
        info01:'21 2643-XXXX',
        info02:'21 9976-XXXX'
    },
    {
        class:"fa-regular fa-envelope",
        label:'E-mail',
        info01:'depaulalivros@depaula.com',
        info02:'editora@editora.com'
    },
]

export const menuLinks = [
    {
        label: 'Home',
        href: '#home',
        class: 'link',
    },
    {
        label: 'Sobre',
        href: '#sobre',
        class: 'link',
    },
    {
        label: 'Resumo',
        href: '#resumo',
        class: 'link',
    },
    {
        label: 'Autor',
        href: '#autor',
        class: 'link',
    },
    {
        label: 'Depoimentos',
        href: '#depoimento',
        class: 'link',
    },
    {
        label: 'Contato',
        href: '#contato',
        class: 'link',
    },
    {
        label: 'FAQ',
        href: '#faq',
        class: 'link',
    }
]

